import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Channel, Topic } from "../../../constants";
import { NativeActionCreators } from "../../../redux/action-creators";

import { UserContextSelectors } from "../../../redux/selectors";
import {
  LocalStorageUtils,
  MessageBrokerUtils,
  TypeUtils
} from "../../../utils";

export const useBiometricsSettings = () => {
  const isNative = useSelector(UserContextSelectors.isNative);

  const dispatch = useDispatch();

  const setEnrollmentStatus = useCallback(
    isEnrolled =>
      dispatch(NativeActionCreators.setBiometricsEnrollmentStatus(isEnrolled)),
    [dispatch]
  );

  useEffect(() => {
    if (isNative) {
      const storeBiometricsIsEnrolled = LocalStorageUtils.get(
        "BiometricsIsEnrolled"
      );
      const isEnrolled = TypeUtils.toBoolean(storeBiometricsIsEnrolled);

      setEnrollmentStatus(isEnrolled);
    }
  }, [isNative, setEnrollmentStatus]);

  useEffect(() => {
    let enrollmentStatusSubscription = null;

    if (isNative) {
      enrollmentStatusSubscription = MessageBrokerUtils.subscribe({
        channel: Channel.BIOMETRICS,
        topic: Topic.enrollmentStatus,
        callback: data => {
          const isEnrolled = TypeUtils.toBoolean(data?.isEnrolled);

          setEnrollmentStatus(isEnrolled);
        }
      });
    }

    return () => {
      enrollmentStatusSubscription?.unsubscribe();
    };
  }, [isNative, setEnrollmentStatus]);

  useEffect(() => {
    let biometricsStatusSubscription = null;

    if (isNative) {
      biometricsStatusSubscription = MessageBrokerUtils.subscribe({
        channel: Channel.BIOMETRICS,
        topic: Topic.biometricsStatus,
        callback: data => {
          const isEnabled = TypeUtils.toBoolean(data?.isEnabled);

          //if player removes biometrics function then remove enrollment status
          if (!isEnabled) setEnrollmentStatus(false);
        }
      });
    }

    return () => {
      biometricsStatusSubscription?.unsubscribe();
    };
  }, [isNative, setEnrollmentStatus]);
};
